import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=17028cc6&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleDetail.vue?vue&type=style&index=1&id=17028cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17028cc6",
  null
  
)

export default component.exports